import React, { memo, useMemo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { trackSettingsInteraction } from 'Pods/ThreeDStudio/Services/studioTracker'
import ToggleSelector from 'Pods/ThreeDStudio/Shared/ToggleSelector/ToggleSelector'
import { providerSupportsParam } from 'Pods/ThreeDStudio/Shared/Utils/providerSupportsParam'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setIsSmartLowPoly } from 'Pods/ThreeDStudio/Store/actions/modelSettings'

const handleSmartLowPolyToggle = (isSmartLowPoly) => {
  trackSettingsInteraction('smart_low_poly', isSmartLowPoly)
  setIsSmartLowPoly(isSmartLowPoly)
}

function SmartLowPolySelector() {
  const t = useTranslation()
  const generationAction = useThreeDStudioStore(state => state.schema.generationAction)
  const generationProvider = useThreeDStudioStore(state => state.schema.generationProvider)
  // The provider is only resolved client-side (resolveInitialGenerationProvider), so it
  // is undefined at SSR. The row stays in the server markup until it lands, since every
  // engine that can take the slot supports smart low poly for the default action; hiding
  // it beforehand would pop it in after hydration and shift the panel.
  const isSupported = useMemo(
    () => generationProvider === undefined
      || providerSupportsParam(generationAction, generationProvider, 'smart_low_poly'),
    [generationAction, generationProvider],
  )

  if (!isSupported) {
    return null
  }

  return (
    <ToggleSelector
      id="model-settings-smart-low-poly"
      keyName="isSmartLowPoly"
      label={t('leftSide.smartLowPoly.label')}
      setFunction={handleSmartLowPolyToggle}
      sliceName="modelSettings"
    />
  )
}

export default memo(SmartLowPolySelector)
